import { AbstractControl, UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';


/**
 * Classe responsável por validação da interface do
 * formuluário com base nas regras e mensagens de
 * validação definidas abaixo.
 */
export class ValidatorForm {

  getErrorMessage(control: AbstractControl) {
    if (control.hasError('required')) {
      return 'Campo obrigatório';
    }

    if (control.hasError('email')) {
      return 'E-mail digitado não é válido';
    }
    if(control.hasError('UNKNOWN_USER')){
      return 'Usuário desconhecido';
    }
    if(control.hasError('UNREGISTERED_USER')){
      return 'Usuário não registrado';
    }
    if(control.hasError('UNREGISTERED_USER')){
      return 'Usuário não registrado';
    }
    if (control.hasError('ALREADY_REGISTERED')) {
      return `E-mail já cadastrado. Utilize um e-mail diferente.`;
    }

    if (control.hasError('invalidPhone')) {
      return `Telefone inválido`;
    }

    if (control.hasError('invalidDDD')) {
      return `DDD inválido`;
    }


    if (control.hasError('passwordNotValid')) {
      const password = control.value;
      const letter = (password.match(/[a-z]+/g)) ? true : false;
      const upper = (password.match(/[A-Z]+/g)) ? true : false;
      const number = (password.match(/[0-9]/g)) ? true : false;
      const limit = (password.length && password.length >= 6) ? true : false;

      let message =  '';
      if(!limit) {
        message += 'A senha deve ter pelo menos 6 caracteres <br>';
      }

      if(!upper) {
        message +=  'Use pelo menos uma letra maiúscula <br>';
      }

      if(!number) {
        message += 'Use pelo menos um número <br>';
      }

      if(!letter) {
        message += 'Use pelo menos uma letra minúscula <br>';
      }

      if(!new RegExp(/(?=.*?[#?!@$%^&*-])/).test(password)) {
        message += 'Use pelo menos um caractere especial <br>';
      }
      return message;
    }

    if (control.hasError('notMatchPassword')) {
      return 'Ambas as senhas devem ser iguais';
    }

    if (control.hasError('cpfNotValid')) {
      return 'Digite um CPF válido';
    }
    if(control.hasError('INVALID_CPF')){
      return 'CPF inválido';
    }
    if(control.hasError('CPF_ALDREADY_REGISTERED')){
      return 'CPF já cadastrado';
    }

    if(control.hasError('creditCardNumberNotValid')) {
      return 'Número do cartão inválido';
    }

    if(control.hasError('ccvNumberNotValid')) {
      return 'Número inválido';
    }

    if(control.hasError('dateCardNotValid')) {
      return 'Data inválida';
    }

    if(control.hasError('dateCardNotValid')) {
      return 'Data inválida';
    }

    if(control.hasError('INVALID_PASSWORD')){
      return 'Password inválido';
    }

    if(control.hasError('UNKNOWN_ERROR')){
      return 'Erro desconhecido';
    }

    if(control.hasError('notOfAge')){
      return 'Menor de idade';
    }

    return '';
  }

  hasError(control: AbstractControl) {
    return control.invalid && (control.dirty || control.touched);
  }

  validateForm(form: AbstractControl) {
    if (form instanceof UntypedFormGroup) {
      Object.keys(form.controls).forEach(field => {
        const control = form.get(field);
        this.validateForm(control);
      });
    } else if (form instanceof UntypedFormControl) {
      form.markAsTouched({ onlySelf: true });
    } else if (form instanceof UntypedFormArray) {
      form.markAsTouched({ onlySelf: true });
      form.controls.forEach(control => {
        this.validateForm(control);
      })
    }
  }

  static patternLink(form: AbstractControl) {
    if (form.value) {
      if (typeof form.value === 'string' && !form.value.startsWith('https:')) {
        return { patternLink: true };
      }
      const isValid = new RegExp(
        /(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[/\w?=&#%\s.-]*/
      ).test(form.value);
      if (!isValid) {
        return { patternLink: true };
      }
    }
	}

}
